<script>
/**
 * tableData是当前页展示的数据，allData是所有的数据
 */
export default {
  name: 'MoreData',
  props: {
    tableData: { // 当前展示的数据
      type: Array,
      default: () => []
    },
    allData: { // 所有数据
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      isMore: true,
    }
  },
  watch: { // 使用watch再重新请求数据时会同步更新
    allData: {
      handler (newV, oldV) {
        let data
        if (this.allData.length > 11) { // 考虑刚好10条+一条汇总
          data = this.allData.slice(0, 10) // 截取10条
          this.$emit('update:tableData', data)
        } else {
          this.$emit('update:tableData', this.allData)
        }
      },
      deep: true
    }
  },
  methods: {
    moreData () {
      if (this.isMore) { // 显示更多
        this.$emit('update:tableData', this.allData)
        this.isMore = false
      } else { // 收起
        this.$emit('update:tableData', this.allData.slice(1, 11))
        this.isMore = true
      }
    },
  },
  render () {
    return (
      <div>
        {this.allData.length > 10 &&
          <div class="data_btn">
            <div class="data_btn_line_left"></div>
            <span class="data_btn_total">共{this.allData.length}条</span>
            <span class="operate_btn" onclick={this.moreData}>{this.isMore ? '显示更多' : '收起'}</span>
            <span class="data_btn_line_right"></span>
          </div>
        }
      </div>
    )
  }
}
</script>
<style lang="scss" scoped>
.data_btn {
  width: 100%;
  text-align: center;
  font-size: 14px;
  height: 40px;
  line-height: 40px;
  background-color: #fff;
  color: #909399;
  position: relative;
  .data_btn_total {
    margin-right: 20px;
  }
  .data_btn_line_left {
    border: 1px solid rgb(235,238,245);
    border-bottom: none;
    height: 1px;
    width: 40%;
    position: absolute;
    top: 20px;
    left: 20px;
  }
  .data_btn_line_right {
    border: 1px solid rgb(235,238,245);
    border-bottom: none;
    height: 1px;
    width: 40%;
    position: absolute;
    top: 20px;
    right: 20px;
  }
  .operate_btn {
    cursor: pointer;
  }
}
</style>
